import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const CompanyPropTypes = PropTypes.shape({
    _id: PropTypes.string,
    active: PropTypes.bool,
    address: PropTypes.shape({
        area: PropTypes.string,
        buildingNo: PropTypes.string,
        cityId: PropTypes.string,
        flatNo: PropTypes.string,
        lat: PropTypes.number,
        lng: PropTypes.number,
        pincode: PropTypes.string,
        stateId: PropTypes.string,
    }),
    authorizedPersonId: PropTypes.string,
    bankInfo: PropTypes.shape({
        accountNumber: PropTypes.string,
        bankName: PropTypes.string,
        ifisc: PropTypes.string,
        pancard: PropTypes.string,
    }),
    cin: PropTypes.string,
    companyDisplayName: PropTypes.string,
    companyName: PropTypes.string,
    companyType: PropTypes.string,
    gstin: PropTypes.string,
    llpn: PropTypes.string,
    pan: PropTypes.string,
});

export const CompanyDefaultProps = {
    _id: '',
    companyName: '',
    companyDisplayName: '',
    companyType: '',
    cin: '',
    llpn: '',
    pan: '',
    gstin: '',
    authorizedPersonId: '',
    bankInfo: {
        pancard: '',
        accountNumber: '',
        ifisc: '',
        bankName: '',
    },
    address: {
        flatNo: '',
        buildingNo: '',
        area: '',
        stateId: '',
        cityId: '',
        pincode: '',
        lat: '',
        lng: '',
    },
    active: true,
};

export const CompanyYupSchema = Yup.object().shape({
    companyName: Yup.string()
        .min(2, 'Too Short!')
        .max(70, 'Too Long!')
        .required('Required'),
    companyDisplayName: Yup.string().required('Required'),
});

export default {
    CompanyDefaultProps,
    CompanyPropTypes,
    CompanyYupSchema,
};
